import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";

function money(v) {
  const n = Number(v || 0);
  return `$${n.toFixed(2)}`;
}

export default function PricingSummaryCard({
  loading,
  error,
  isTableBooking = false,
  isBottleServiceBooking,
  hasTicketBooking = false,
  hasBoothBooking = false,
  pricing,
  membersCount,
  bookingDays,
}) {
  const showTicketPriceLine =
    !isTableBooking && (hasTicketBooking || hasBoothBooking);

  return (
    <div className="review-price-list">
      {loading ? (
        <div className="review-row">
          <span>Loading summary...</span>
          <strong>...</strong>
        </div>
      ) : null}
      {error ? (
        <div className="review-row">
          <span style={{ color: colors.red }}>{error}</span>
          <strong />
        </div>
      ) : null}
      {isBottleServiceBooking ? (
        <>
          <div className="review-row review-row--multi-line">
            <span>
              Bottle service total
              <span className="review-row-hint">(Alcoholic and nonalcoholic Price)</span>
            </span>
            <strong>{money(pricing.bottleServiceTotal)}</strong>
          </div>
          <div className="review-row">
            <span>Alcoholic total</span>
            <strong>{money(pricing.alcoholicTotal)}</strong>
          </div>
          <div className="review-row">
            <span>Non-alcoholic total</span>
            <strong>{money(pricing.nonAlcoholicTotal)}</strong>
          </div>
          <div className="review-row">
            <span>Reservation fee</span>
            <strong>{money(pricing.reservationFeeAmount ?? 0)}</strong>
          </div>
          <div className="review-row review-row--multi-line review-row--subtotal">
            <span>
              Subtotal
              <span className="review-row-hint">(Bottle service Total + Reservation Fee)</span>
            </span>
            <strong>{money(pricing.subtotal ?? 0)}</strong>
          </div>
        </>
      ) : (
        <>
          {isTableBooking ? (
            <>
              <div className="review-row">
                <span>{`Male Price (${pricing.maleCount ?? 0} males x ${bookingDays} days)`}</span>
                <strong>{money(pricing.maleTotal)}</strong>
              </div>
              <div className="review-row">
                <span>{`Female Price (${pricing.femaleCount ?? 0} females x ${bookingDays} days)`}</span>
                <strong>{money(pricing.femaleTotal)}</strong>
              </div>
            </>
          ) : null}
          {!showTicketPriceLine ? (
            <div className="review-row">
              <span>{`Entry Fee (${membersCount} members x ${bookingDays} days)`}</span>
              <strong>{money(pricing.entryFeeAmount)}</strong>
            </div>
          ) : null}
          {showTicketPriceLine ? (
            <div className="review-row">
              <span>{`Ticket Price (${membersCount} members x ${bookingDays} days)`}</span>
              <strong>{money(pricing.ticketPrice)}</strong>
            </div>
          ) : null}
        </>
      )}
      <div className="review-row">
        <span>Discount</span>
        <strong className={pricing.discount > 0 ? "review-discount-amount" : ""}>
          {pricing.discount > 0 ? `-${money(pricing.discount)}` : money(pricing.discount)}
        </strong>
      </div>
      <div className="review-row">
        <span>Taxes</span>
        <strong>{money(pricing.hst)}</strong>
      </div>
      <div className="review-row">
        <span>Platform Fee</span>
        <strong>{money(pricing.platformFee)}</strong>
      </div>
      <div className="review-row">
        <span>{`Gratuity${pricing.gratuityPercent ? ` (${pricing.gratuityPercent}%)` : ""}`}</span>
        <strong>{money(pricing.gratuityAmount)}</strong>
      </div>
      <div className="review-total-row">
        <span>{isBottleServiceBooking ? "Total Price" : "Total"}</span>
        <strong>{money(pricing.total)}</strong>
      </div>
    </div>
  );
}
